<template>
    <div>
        <img :src="url" />
    </div>
</template>

<script>
export default {
    props: ['item'],
    name: "SingleItemImage",
    computed: {
        url() {
            if (this.item.image_urls && this.item.image_urls.length > 0) {
                return this.item.image_urls[0].url;
            }
            return this.$assets.missingImageUrl;
        }
    }
}
</script>

<style scoped>

</style>
